import React, { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { collection, getDocs } from 'firebase/firestore';

import { db } from '../firebase';
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default; // eslint-disable-line
mapboxgl.accessToken = "pk.eyJ1Ijoic3BhdGlhbG9yYWNsZXMiLCJhIjoiY2wzbmh0YXpwMDAwYzNpbnoxcmsyOWdlZSJ9.9ee8oy8abpOPlQ7JUo7ccA";

const Map = () => {
  const imageCollectionRef = collection(db, "images");

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-93.8686904, 40.7783317],
      zoom: 4
    })

    loadImage(map);

    // Add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl(), 'top-left');

    // Clean up on unmount
    return () => map.remove();
  }, [])

  const loadImage = async (map) => {
    const data = await getDocs(imageCollectionRef);

    const images = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    console.log(images);

    images.map(i => (
      new mapboxgl.Marker()
      .setLngLat(i.location)
      .setPopup(
        new mapboxgl.Popup({ offset: 25 }) // add popups
          .setHTML(
            `<a href="https://spatialoracles-8b65a.web.app/#/image/${i.id}" target="_blank" title="See 360 image in a new window"><img id="img" src=${i.url} width="100" /></a>`
          )
      )
      .addTo(map)
    ))

    

    return images;
  }

  return (
    <div className='map-container'>
      <div id='map' />
    </div>
  )
}

export default Map;